var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5833 7.34635C13.5833 3.66445 10.5986 0.679688 6.91667 0.679688C3.23477 0.679688 0.25 3.66445 0.25 7.34635C0.25 10.6739 2.6879 13.4319 5.875 13.932V9.27344H4.18229V7.34635H5.875V5.8776C5.875 4.20677 6.87029 3.28385 8.3931 3.28385C9.12249 3.28385 9.88542 3.41406 9.88542 3.41406V5.05469H9.04477C8.2166 5.05469 7.95833 5.56858 7.95833 6.09579V7.34635H9.80729L9.51172 9.27344H7.95833V13.932C11.1454 13.4319 13.5833 10.6739 13.5833 7.34635Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50911 9.27083L9.80469 7.34375H7.95573V6.09319C7.95573 5.56598 8.214 5.05208 9.04216 5.05208H9.88281V3.41146C9.88281 3.41146 9.11988 3.28125 8.39049 3.28125C6.86768 3.28125 5.8724 4.20417 5.8724 5.875V7.34375H4.17969V9.27083H5.8724V13.9294C6.21181 13.9827 6.55969 14.0104 6.91406 14.0104C7.26844 14.0104 7.61632 13.9827 7.95573 13.9294V9.27083H9.50911Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.e8f1eac2edff08419a43d950f811d4d1.svg";
export { ForwardRef as ReactComponent };